import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  items: ".animation--container > *",
  image: ".animation--image",
  imageCaption: ".animation--image-caption"
};

export default node => {
  // Add the animation delay offset variables
  delayOffset(node, [selectors.image, selectors.imageCaption]);
  delayOffset(node, [selectors.items], 6);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};

